import { Injectable } from '@angular/core';
import {Level, Log} from 'ng2-logger';
import {Lang} from '../lang-picker/support-lang/support-lang';

/**
 * we use this time to define all the log, for example, we log in several component, and every component is on log item.
 */
export interface LogEntry {
  key: string;
  color: string;
  name: string;
  level: Level [];
}

export const LOG_ENTRIES: { [key: string]: LogEntry} = {
  lang_picker : {
    key: 'lang-picker',
    color: '#ff1100',
    name: 'lang-picker',
    level: [Level.INFO]
  },
  navbar : {
    key: 'navbar',
    color: '#0054ff',
    name: 'navbar',
    level: [Level.INFO]
  },
  app : {
    key: 'app',
    color: '#00ff1c',
    name: 'app',
    level: [Level.INFO]
  } ,
  home_page : {
    key: 'home_page',
    color: '#ff5cef',
    name: 'home_page',
    level: [Level.INFO]
  },
  drawer_toggle : {
    key: 'drawer_toggle',
    color: '#20a1ff',
    name: 'drawer_toggle',
    level: [Level.INFO]
  },
  drawer_menu : {
    key: 'drawer_menu',
    color: '#ff3a99',
    name: 'drawer_menu',
    level: [Level.INFO]
  }
};

@Injectable()
export class LogHelperService {

  constructor() { }

  iniLoggerConfig() {
    // enable production mode in your app
    // Log.setProductionMode();
    // Log.onlyModules('src:config');
    Log.onlyLevel(Level.ERROR, Level.WARN, Level.DATA, Level.INFO);
  }
}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/shared/log-helper/log-helper.service.ts